import { useEffect, useState } from "react";
import baseUrl from "../../../../../api/baseUrl";
import { stageLabCategory } from "../../../../setting/managetreatment/treatmentlist/stageLabFlags";

/**
 * Lab orders made from a treatment sheet stage (requirement 10). A catalog
 * stage flagged "Lab order" carries the master lab category; the sheet stage
 * then offers to create the order, or shows it once made (labOrderId).
 */

const names = (list: unknown) => (Array.isArray(list) ? list.map((s) => String(s ?? "").trim()).filter(Boolean) : []);

/**
 * The lab category for a sheet stage, picked like its stages: the sub
 * type's own stages, else the type's, else the treatment's. "" = no lab order.
 */
export function resolveStageLabCategory(
  catalog: any[],
  treatmentId: string,
  typeId: string,
  subtypeId: string,
  stage: string
): string {
  if (!catalog?.length || !treatmentId || !String(stage || "").trim()) return "";
  const main = catalog.find((item: any) => String(item._id) === String(treatmentId));
  if (!main) return "";
  const typeItem = typeId ? main.type?.find((t: any) => String(t._id) === String(typeId)) : null;
  if (subtypeId && typeItem) {
    const subtype = typeItem.subType?.find((s: any) => String(s._id) === String(subtypeId));
    if (names(subtype?.stages).length) return stageLabCategory(subtype, stage);
  }
  if (typeItem && names(typeItem.stages).length) return stageLabCategory(typeItem, stage);
  return stageLabCategory(main, stage);
}

/** "11, 12" or ["11","12"] → ["11","12"] for the tooth chart. */
export function stageToothNos(raw: unknown): string[] {
  if (Array.isArray(raw)) return raw.map((t) => String(t).trim()).filter(Boolean);
  return String(raw ?? "")
    .split(/[,\s]+/)
    .map((t) => t.trim())
    .filter(Boolean);
}

let catalogCache: { at: number; data: any[] } | null = null;
const CACHE_MS = 5 * 60 * 1000;

/** The clinic's treatment catalog (stages and their flags), shared by every stage row. */
export function useTreatmentCatalog(enabled = true) {
  const [catalog, setCatalog] = useState<any[]>(catalogCache?.data ?? []);
  useEffect(() => {
    if (!enabled) return;
    if (catalogCache && Date.now() - catalogCache.at < CACHE_MS) {
      setCatalog(catalogCache.data);
      return;
    }
    let cancelled = false;
    baseUrl
      .get("alltreatment/findAllTreatment")
      .then((res) => {
        const data = Array.isArray(res.data?.data) ? res.data.data : [];
        catalogCache = { at: Date.now(), data };
        if (!cancelled) setCatalog(data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [enabled]);
  return catalog;
}
